import script from "./elePriceDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./elePriceDetail.vue?vue&type=script&setup=true&lang=js"

import "./elePriceDetail.vue?vue&type=style&index=0&id=3628a53b&lang=less"

const __exports__ = script;

export default __exports__